import React from 'react';
import { Link } from "react-router-dom";


export default function EmailField({handleSubmit, handleChange, formValues, errors, Logo, loading}) {
  return (
    <form
    className="card-body cardbody-color p-lg-5 bg-glass"
    onSubmit={handleSubmit}
  >
    <div className="text-center">
      <img
        src={Logo}
        className="img-fluid profile-image-pic img-thumbnail rounded-circle mb-5"
        width="200px"
        alt="profile"
      />
    </div>



    <div className="mb-3">
      <input
        name="email"
        type="text"
        className={
          errors.email
            ? "form-control border border-danger"
            : "form-control"
        }
        id="email"
        placeholder="Email"
        value={formValues.email}
        onChange={(e)=>handleChange(e, 'email')}
        autoComplete="new-username"
      />
      {errors.email && (
        <span style={{ color: "red" }}>{errors.email}</span>
      )}
    </div>

  



    <div className="text-center">
      <button
        type="submit"
        className="btn btn-color px-5 mt-1 mb-1 w-100"
        disabled={loading}
      >
        {" "}
        {loading ? "Loading..." : "Send OTP"}
      </button>
    </div>

    <Link className="forgot-pass-text" to="/login" >Back to Login</Link>

  </form>
  )
}
